import axios from "axios";
import { getDate } from "./Utils";

export const transferInvoice = async ( ncfTypeId, fromDate, toDate, invoiceId ) => {
    // if ( isNaN(parseInt(ncfTypeId)) || parseInt(ncfTypeId) < 1 )
    // {
    //     callInvoiceDocument()
    //     return;
    // }
    const oshenLocToken = localStorage.getItem('OSHEN-LOC-STR-WT');
    try {
        //consultar datos de la factura a enviar...
        const resourceInvoiceData = await axios.get(
            `${process.env.REACT_APP_NV_API_PATH}/sales/${ncfTypeId}/${fromDate}/${toDate}/${invoiceId}`,
            {
                headers: {
                    "Authorization": `Bearer ${oshenLocToken}`
                }
            }            
        ),
        invoiceData = resourceInvoiceData.data
        
        console.log('invoiceData>>',invoiceData)

        if ( invoiceData === undefined || invoiceData === null ) {
            return false
        }

        //transferencia de documento
        const resourceTransferInvoice = await axios.post(
            `${process.env.REACT_APP_NV_API_PATH}/sales/doc/${ncfTypeId}`,
            invoiceData.data[0],
            {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${oshenLocToken}`
                }                
            }
        ),
        feData = resourceTransferInvoice.data

        console.log('resourceTransferInvoice>>',resourceTransferInvoice)

        //guardar datos de transferencia...
        const splitTimeStamp = feData.signatureDate.split(" ")
        const splitDate = feData.signatureDate.split("-")
        const signatureDateText = `${splitDate[2]}-${splitDate[1]}-${splitDate[0]}`
        const signatureTimestamp = `${getDate(signatureDateText)} ${splitTimeStamp[1]}`
        const resourceSaveData = await axios.post(
            `${process.env.REACT_APP_NV_API_PATH}/sales`,
            {
                doc_id: feData.id,
                status: feData.status,
                encf: feData.encf,
                signature_date: signatureTimestamp,
                security_code: feData.securityCode,
                sequence_consumed: feData.sequenceConsumed,
                document_stamp_url: feData.documentStampUrl
            },
            {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${oshenLocToken}`
                }                
            }
        )

        console.log('resourceSaveData:::',resourceSaveData)
        return true;

    } catch ( err ) {        
        console.log('err::', err)
        return false
    }    
}